import { setPersonId } from './settings'
import {
  studentEnrollmentsQuery,
  joinCourseDetailsQuery,
  studentInfoAndRegistrationQuery,
} from '../graphql/student'
import { userSettingsQuery } from '../graphql/settings'

export const setStudentEnrollments = ({ client, educationPeriod }) => {
  try {
    client.writeQuery({
      query: studentEnrollmentsQuery,
      variables: { code: educationPeriod },
      data: {
        getStudentEnrollments: {
          scoreSendData: {
            diCode: null,
            userPromptType: null,
          },
          courseEnrollments: [],
          __typename: 'studentEnrollments',
        },
      },
    })
  } catch (err) {
    console.info(err)
  }
}

export const updateStudentRegistration = ({ cache, data, educationPeriod, refresh }) => {
  try {
    cache.writeQuery({
      query: studentInfoAndRegistrationQuery,
      variables: { code: educationPeriod, isRegistration: true, isStudent: true, refresh },
      data: {
        getStudentInfoAndRegistration: {
          ...data,
          __typename: 'studentInfoAndRegistration',
        },
      },
    })
    setPersonId(cache, data.studentId)
    return data
  } catch (err) {
    console.info(err)
    return {}
  }
}

export const updateStudentInformation = ({ cache, data, educationPeriod, refresh }) => {
  try {
    cache.writeQuery({
      query: studentInfoAndRegistrationQuery,
      variables: { code: educationPeriod, isProfile: true, isStudent: true, refresh },
      data: {
        getStudentInfoAndRegistration: {
          ...data,
          __typename: 'studentInfoAndRegistration',
        },
      },
    })
    setPersonId(cache, data.studentId)
    return data
  } catch (err) {
    console.info(err)
    return {}
  }
}

export const mergeBfsDataIntoStudentReg = ({ cache, data, educationPeriod }) => {
  try {
    // we never need to update if `refresh=true`, as latest registration server data
    // will be available when I need to read the bfs info
    const variables = { code: educationPeriod, isStudent: true, refresh: false }

    const existingRegInfo = cache.readQuery({
      query: studentInfoAndRegistrationQuery,
      variables,
    })

    if (existingRegInfo?.getStudentInfoAndRegistration) {
      const { phoneNumber, recoveryEmailAddress } = data
      const mappedData = {
        ...(phoneNumber !== undefined && { bfsPhoneNumber: phoneNumber }),
        ...(recoveryEmailAddress !== undefined && { recoveryEmailAddress }),
      }
      cache.writeQuery({
        query: studentInfoAndRegistrationQuery,
        variables,
        data: {
          getStudentInfoAndRegistration: {
            ...existingRegInfo.getStudentInfoAndRegistration,
            ...mappedData,
            __typename: 'studentInfoAndRegistration',
          },
        },
      })
    }
    return data
  } catch (err) {
    console.info(err)
    return data
  }
}

export const clearStudentBfsDataIfNoBfsEnrollments = ({ cache, educationPeriod }) => {
  try {
    const variables = { code: educationPeriod, isStudent: true, refresh: false }
    const settings = cache.readQuery({
      query: userSettingsQuery,
    })
    const existingRegInfo = cache.readQuery({
      query: studentInfoAndRegistrationQuery,
      variables,
    })

    const hasBfsEnrollments = settings.getUserSettings.educationPeriods.find(
      edpd => edpd.chronology === 'current' && edpd.hasBfsEligibleEnrollments
    )?.hasBfsEligibleEnrollments
    if (existingRegInfo?.getStudentInfoAndRegistration && !hasBfsEnrollments) {
      cache.writeQuery({
        query: studentInfoAndRegistrationQuery,
        variables,
        data: {
          getStudentInfoAndRegistration: {
            ...existingRegInfo.getStudentInfoAndRegistration,
            bfsPhoneNumber: null,
            recoveryEmailAddress: null,
            bfsOptedDate: null,
            __typename: 'studentInfoAndRegistration',
          },
        },
      })
    }
  } catch (err) {
    console.info(err)
  }
}

export const updateStudentEnrollments = ({ cache, response, key, educationPeriod }) => {
  const {
    data: {
      [key]: {
        courseEnrollments,
        scoreSendData: { diCode, userPromptType },
      },
    },
  } = response
  // console.log('updateStudentEnrollments (action) - enrollment complete, update cache')
  cache.writeQuery({
    query: studentEnrollmentsQuery,
    variables: { code: educationPeriod },
    data: {
      getStudentEnrollments: {
        scoreSendData: {
          diCode,
          userPromptType,
          __typename: 'scoreSend',
        },
        courseEnrollments,
        __typename: 'studentEnrollments',
      },
    },
  })
}

export const saveStudentScoreSend = ({ cache, response, educationPeriod }) => {
  const attributes = {
    query: studentEnrollmentsQuery,
    variables: { code: educationPeriod },
  }
  const {
    data: {
      saveStudentScoreSend: { diCode, userPromptType },
    },
  } = response

  if (saveStudentScoreSend) {
    const {
      getStudentEnrollments: { courseEnrollments },
    } = cache.readQuery(attributes)

    cache.writeQuery({
      ...attributes,
      data: {
        getStudentEnrollments: {
          scoreSendData: {
            diCode,
            userPromptType,
            __typename: 'scoreSend',
          },
          scoreSendSaved: true,
          courseEnrollments,
          __typename: 'studentEnrollments',
        },
      },
    })
  }
}

export const setJoinCourseDetails = (
  client,
  { enrollmentCode, sectionId, languageRegularlySpoken = null, isMove = false, enrollmentId = null }
) => {
  client.writeQuery({
    query: joinCourseDetailsQuery,
    data: {
      getJoinCourseDetails: {
        enrollmentCode,
        sectionId,
        languageRegularlySpoken,
        isMove,
        enrollmentId,
        __typename: 'joinCourseDetails',
      },
    },
  })
}
